import AudioPlaybackPopupContainer from './AudioPlaybackPopupContainer';

export default AudioPlaybackPopupContainer;